// G-Solar Power and VS Alpha are invoiced together and share ONE running number:
// 27-0007/GSP/ALM and 27-0007/VS/ALM are a pair. The shared counter
// (invoiceCounters/GSOLAR_{yy}) holds the last number used, so:
//   - the first invoice of a new number must be exactly last + 1, and
//   - its sibling (same number, the other company's prefix) is accepted too,
//     but only once the first of the pair exists.
// Any other number would leave a gap or re-use one, and is refused.
export const GSOLAR_NUMBER_PATTERN = /^(\d{2})-(\d{3,})\/(GSP|VS)\/ALM$/;

export const siblingInvoiceNumber = (invoiceNumber) => {
  const match = String(invoiceNumber).toUpperCase().match(GSOLAR_NUMBER_PATTERN);
  if (!match) return null;
  const [, yy, sequence, prefix] = match;
  return `${yy}-${sequence}/${prefix === "GSP" ? "VS" : "GSP"}/ALM`;
};

// Returns "" when the number may be approved, otherwise the reason it may not.
export function checkGsolarSequence({ currentLast, sequence, yy, siblingExists }) {
  const last = Number(currentLast || 0);
  const seq = Number(sequence);
  if (last === 0) return ""; // first invoice in the system: any starting number seeds the series
  if (seq === last + 1) return "";
  if (seq === last && siblingExists) return "";
  const next = String(last + 1).padStart(4, "0");
  if (seq === last) {
    return `${yy}-${String(seq).padStart(4, "0")} was already used by the other company's invoice, not this one. The next number is ${yy}-${next}/GSP/ALM (or the VS/ALM equivalent) — regenerate the invoices to get it.`;
  }
  return `The next approvable G-Solar/VS Alpha number is ${yy}-${next}/GSP/ALM (or the equivalent VS/ALM number). This prevents number gaps.`;
}
